module.exports = __webpack_public_path__ + "img/fb.31519585.svg";